<template>
  <div class="pagination">
    <a-pagination
      size="small"
      v-model="currentPage"
      :total="+total"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageList"
      @showSizeChange="pageSizeChanged"
      :show-total="(total) => `Total ${total} items`"
    />
  </div>
</template>

<script>
import { pagination } from "ant-design-vue";
export default {
  props: ["pageSize", "pageNo", "total", "pages", "id"],
  components: { "a-pagination": pagination },
  data() {
    const pages = this.pages
      ? this.pages.split(",")
      : ["10", "50", "100", "200"];
    return {
      pageList: pages,
      stop: false,
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.pageNo;
      },
      set(val) {
        if (this.stop) {
          this.stop = false;
          return;
        }
        this.$emit("paginate", {
          page_no: val,
          page_size: this.pageSize,
        });
      },
    },
  },
  methods: {
    pageSizeChanged(current, page_size) {
      if (this.currentPage !== 1) {
        this.stop = true;
      }
      this.$emit("paginate", {
        page_no: 1,
        page_size,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  padding: 15px;
  display: flex;
  justify-content: flex-end;
}
</style>